import React, {useEffect, useState} from "react";
import styles from "./NewsletterBenefits.module.scss";
import {useTranslation} from "react-i18next";
import ReactDOM from "react-dom";
import {excludedManufacturers} from "../../../lib/ModalWindow/ApplicableVouchersModal";
import window from "../../../lib/WindowExtended";
import formatCurrency from "../../../../helpers/formatCurrency";
import {CurrencyCode} from "@connox/typescript-library/types/cart/CurrencyCode";

const NewsletterBenefits: React.FC = () => {
  const {t} = useTranslation("customerAccount");

  const [benefitsPortalDiv, setBenefitsPortalDiv] = useState<HTMLDivElement | null>();

  useEffect(() => {
    const footerNoteDiv = document.getElementById("footerNote") as HTMLDivElement;
    if (footerNoteDiv) {
      setBenefitsPortalDiv(footerNoteDiv);
    } else {
      const section = document.createElement("section");
      const div = document.createElement("div");
      div.id = "footerNote";
      section.append(div);
      document.querySelector("footer")?.insertAdjacentElement("beforebegin", section);
      setBenefitsPortalDiv(div);
    }

    return () => {
      setBenefitsPortalDiv(null);
    };
  }, []);

  const FooterNote = () => {
    return (
      <div className={styles.footerNote}>
        <sup>1</sup>{" "}
        {t("GutscheinFußnote", {
          manufacturers: excludedManufacturers,
          minOrderValue: formatCurrency(79.0, window.c_ActiveCurrency as CurrencyCode),
        })}
      </div>
    );
  };

  return (
    <div className={styles.wrapper}>
      <h3>{t("Ihre Vorteile im Überblick")}</h3>
      <div className={styles.benefitsWrapper}>
        <div className={styles.block}>
          <span className={`${styles.icon} ${styles.percent}`} />
          <div>
            <h3>{t("Keine Rabattaktion mehr verpassen")}</h3>
            <p>{t("Profitieren Sie von regelmäßigen exklusiven Angeboten.")}</p>
          </div>
        </div>
        <div className={styles.block}>
          <span className={`${styles.icon} ${styles.info}`} />
          <div>
            <h3>{t("Neuheiten, Expertentipps, Homestorys")}</h3>
            <p>
              {t(
                "Erfahren Sie als Erster von Design-Neuheiten und erhalten Sie Interior-Tipps von unseren Einrichtungsexperten.",
              )}
            </p>
          </div>
        </div>
        <div className={styles.block}>
          <span className={`${styles.icon} ${styles.coins}`} />
          <div>
            <h3>{t("Gewinnspiele, Wohntrends und vieles mehr")}</h3>
            <p>
              {t(
                "Gewinnen Sie attraktive Design-Preise und bleiben Sie über aktuelle Wohntrends jederzeit informiert.",
              )}
            </p>
          </div>
        </div>
        <div className={styles.block}>
          <span className={`${styles.icon} ${styles.gift}`} />
          <div>
            <h3>{t("Willkommensgeschenk erhalten")}</h3>
            <p>
              {t("Jetzt anmelden und 12 %-Willkommensrabatt sichern.")}
              <sup>1</sup>
            </p>
            {benefitsPortalDiv && ReactDOM.createPortal(<FooterNote />, benefitsPortalDiv)}
          </div>
        </div>
        <div className={styles.block}>
          <span className={`${styles.icon} ${styles.close}`} />
          <div>
            <h3>{t("Kostenlos und jederzeit kündbar")}</h3>
            <p>{t("Selbstverständlich können Sie sich jederzeit kostenlos vom Newsletter abmelden.")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsletterBenefits;
